export const ALOG_GET_ALOG_LIST_BEGIN = 'ALOG_GET_ALOG_LIST_BEGIN';
export const ALOG_GET_ALOG_LIST_SUCCESS = 'ALOG_GET_ALOG_LIST_SUCCESS';
export const ALOG_GET_ALOG_LIST_FAILURE = 'ALOG_GET_ALOG_LIST_FAILURE';
export const ALOG_GET_ALOG_LIST_DISMISS_ERROR = 'ALOG_GET_ALOG_LIST_DISMISS_ERROR';
export const ALOG_SUBMIT_ALOG_BEGIN = 'ALOG_SUBMIT_ALOG_BEGIN';
export const ALOG_SUBMIT_ALOG_SUCCESS = 'ALOG_SUBMIT_ALOG_SUCCESS';
export const ALOG_SUBMIT_ALOG_FAILURE = 'ALOG_SUBMIT_ALOG_FAILURE';
export const ALOG_SUBMIT_ALOG_DISMISS_ERROR = 'ALOG_SUBMIT_ALOG_DISMISS_ERROR';
export const ALOG_DELETE_ALOG_BEGIN = 'ALOG_DELETE_ALOG_BEGIN';
export const ALOG_DELETE_ALOG_SUCCESS = 'ALOG_DELETE_ALOG_SUCCESS';
export const ALOG_DELETE_ALOG_FAILURE = 'ALOG_DELETE_ALOG_FAILURE';
export const ALOG_DELETE_ALOG_DISMISS_ERROR = 'ALOG_DELETE_ALOG_DISMISS_ERROR';
export const ALOG_ALOG_MODAL_CHANGE = 'ALOG_ALOG_MODAL_CHANGE';
export const ALOG_CHOOSE_CURRENT_ALOG = 'ALOG_CHOOSE_CURRENT_ALOG';




// WEBPACK FOOTER //
// ./src/features/alog/redux/constants.js